/* USER INFO PROFILE */
export const INFO_PROFILE_FETCH_REQUEST = "INFO_PROFILE_FETCH_REQUEST";
export const INFO_PROFILE_FETCH_SUCCESS = "INFO_PROFILE_FETCH_SUCCESS";
export const INFO_PROFILE_FETCH_FAILURE = "INFO_PROFILE_FETCH_FAILURE";

export const INFO_PROFILE_UPDATE_IMAGE = "INFO_PROFILE_UPDATE_IMAGE";
export const INFO_PROFILE_UPDATE_TEXT = "INFO_PROFILE_UPDATE_TEXT";
export const INFO_PROFILE_ADD_TOPIC = "INFO_PROFILE_ADD_TOPIC";
